import { connect } from "react-redux";
import { Link } from "react-router-dom";

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var Glyphicon = require("components/utility/icons/Glyphicon");

var DataRouting = require("lib/routing/DataRouting");
var OrgTypes = require("lib/academic/OrgTypes");
var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");

require("org/org_dropdown.scss");

@connect(
	(state, props) => {
		var loading = RosterSelectors.isLoadingStudentLists({ state });

		if (loading) {
			var selectedText = "Loading classes...";
		} else {
			var selectedText = RosterSelectors.nameForOrgIdentifier({
				state, fallback: "Select one",
				orgIdentifier: props.selectedIdentifier
			});
		}

		if (props.selectionTypes) {
			var selectionTypes = props.selectionTypes;
		} else {
			var selectionTypes = [OrgTypes.ALL_STUDENTS, OrgTypes.STUDENT_LIST];

			if (CurrentUser.isTeacherAdmin()) {
				selectionTypes.push(OrgTypes.SUBGROUP);

			} else if (CurrentUser.isDistrictAdmin()) {
				selectionTypes.push(OrgTypes.SCHOOL_ORG);
			}			
		}

		if (props.omitSelectionTypes) {
			selectionTypes = _.difference(selectionTypes, props.omitSelectionTypes);
		}

		return {
			selectedText, loading, selectionTypes,
			studentLists: RosterSelectors.nonEmptyStudentLists({ state }),
			schoolOrgs: RosterSelectors.schoolOrgs({ state }),
			subgroups: RosterSelectors.subgroups({ state })
		}
	},
	(dispatch, props) => ({})
)

class OrgDropdown extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		// No state. Do not add state. Control from above.
	}

	selectAllOption(type) {
		this.props.onSelect(OrgTypes.toIdentifier({ type }), 'everyone');
	}

	selectSchoolOrg(schoolOrg) {
		this.props.onSelect(OrgTypes.toIdentifier({
			type: OrgTypes.SCHOOL_ORG,
			key: schoolOrg.id
		}));		
	}

	selectStudentList(studentList) {
		if (studentList && studentList.id) {
			this.props.onSelect(OrgTypes.toIdentifier({
				type: OrgTypes.STUDENT_LIST,
				key: studentList.id
			}), studentList.id);
		}
	}

	selectSubgroup(group) {
		this.props.onSelect(OrgTypes.toIdentifier({
			type: OrgTypes.SUBGROUP,
			key: group.key
		}));
	}

	isSupportedType(type) {
		return _.contains(this.props.selectionTypes, type);
	}
	// sets intiial selected student list
	setSelected(selectedList) {
		this.selectStudentList(selectedList)
	}

	render() {

		if (!this.props.loading) {
			var everyoneOptions = []

			if (this.isSupportedType(OrgTypes.ALL_SCHOOL_ORGS)) {
				everyoneOptions.push((
					<ButtonDropdownOption className="topLevel"
						key={ OrgTypes.ALL_SCHOOL_ORGS }
						onClick={ () => this.selectAllOption(OrgTypes.ALL_SCHOOL_ORGS) }>
						All Schools
					</ButtonDropdownOption>
				));
			}

			if (this.isSupportedType(OrgTypes.ALL_STUDENT_LISTS)) {
				everyoneOptions.push((
					<ButtonDropdownOption className="topLevel"
						key={ OrgTypes.ALL_STUDENT_LISTS }
						onClick={ () => this.selectAllOption(OrgTypes.ALL_STUDENT_LISTS) }>
						All Classes
					</ButtonDropdownOption>
				));
			}

			// FOR LOAD REASONS WE DISABLED EVERYONE
			// if (this.isSupportedType(OrgTypes.ALL_STUDENTS)) {
			// 	everyoneOptions.push((
			// 		<ButtonDropdownOption className="topLevel"
			// 			key={ OrgTypes.ALL_STUDENTS }
			// 			onClick={ () => this.selectAllOption(OrgTypes.ALL_STUDENTS) }>
			// 			All Students
			// 		</ButtonDropdownOption>
			// 	));
			// }

			if (this.isSupportedType(OrgTypes.SCHOOL_ORG)) {
				var schoolOrgHeader = (
					<li className="dropdown-header">Schools</li>
				);
				if (this.props.schoolOrgs.length) {
					var schoolOrgOptions = _.sortBy(this.props.schoolOrgs, "name").map((so) => {
						return (
							<ButtonDropdownOption onClick={ () => this.selectSchoolOrg(so) } key={ so.id }>
								{ so.name }
							</ButtonDropdownOption>
						);
					});
				} else {
					var schoolOrgOptions = (
						<li className="placeholder">
							No schools have students.
						</li>
					)
				}
			}

			if (this.isSupportedType(OrgTypes.STUDENT_LIST)) {
				var studentListHeader = (
					<li className="dropdown-header">Classes</li>
				);
				if (this.props.studentLists.length) {
					var selectedList = null
					// preselect list if url param exists
					var studentListOptions = _.sortBy(this.props.studentLists, "name").map((sl) => {
						if (parseInt($wr.getURLParameterByName('student_list')) === sl.id) {
							selectedList = sl
						}
						return (
							<ButtonDropdownOption onClick={ () => this.selectStudentList(sl) } key={ sl.id }>
								{ sl.name }
							</ButtonDropdownOption>
						);
					});
					//this.setSelected(selectedList);  ///////// THIS TRIGGERED UNECESSARY UPDATE MID RENDERING MAY WANT TO REMOVE AT SOME POINT
				} else {
					var studentListOptions = (
						<li className="placeholder">
							<Link to="/roster">
								No classes have students. <span className="linkStyle">Fix</span>
							</Link>
						</li>
					)
				}
			}

			if (this.isSupportedType(OrgTypes.SUBGROUP)) {
				var subgroupHeader = (
					<li className="dropdown-header">Groups</li>
				);
				if (this.props.subgroups.length) {
					var subgroupOptions = _.sortBy(this.props.subgroups, "name").map((group) => {
						return (
							<ButtonDropdownOption onClick={ () => this.selectSubgroup(group) } key={ group.key }>
								<Glyphicon icon={ group.icon } style={{ color: group.color }} />
								{ group.name }
							</ButtonDropdownOption>
						);
					});					
				} else {
					var subgroupOptions = (
						<li className="placeholder">
							<a href="https://whooosreading.zendesk.com/hc/en-us/articles/360046698892" target="_blank">
								No groups yet. Learn more <Glyphicon icon="new-window" />
							</a>
						</li>
					)
				}
			}
		}

		return (
			<div className="orgDropdown">
				<ButtonDropdown text={ this.props.selectedText } className="nested"
					dropdownDisplay={ this.props.dropdownDisplay }>

					{ everyoneOptions }

					{ schoolOrgHeader }
					{ schoolOrgOptions }

					{ studentListHeader }
					{ studentListOptions }

					{ subgroupHeader }
					{ subgroupOptions }
				</ButtonDropdown>
			</div>
		)
	}
};

OrgDropdown.WrappedComponent.propTypes = StrictPropTypes({
	onSelect: PropTypes.func.isRequired, // Is passed an org indetifier object (see OrgTypes module)
	selectedIdentifier: PropTypes.string, // See OrgTypes to/from identifiers
	dropdownDisplay: PropTypes.string,
	omitSelectionTypes: PropTypes.array,

	// From above and/or data inserted by @connect
	selectionTypes: PropTypes.array, // List of types of org types to list. Default is all.

	// Data inserted by @connect
	schoolOrgs: PropTypes.array.isRequired,
	studentLists: PropTypes.array.isRequired,
	subgroups: PropTypes.array.isRequired,
	loading: PropTypes.bool,
	selectedText: PropTypes.string,
});

var ALL_CLASSES_FAKE_ID = -999;

module.exports = OrgDropdown;



// WEBPACK FOOTER //
// ./modules/components/org/OrgDropdown.js